// ProtectedRoute.js
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  if (!userData) {
    // Redirect to login if not logged in
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedRoute;
